var file_upload_viewer_default = {
  "fontElementMap": "i6itt",
  "file_upload_container": "A0mtK",
  "file_upload_link": "qNNg1",
  "file_upload_error_container": "_1aI57",
  "file_upload_file_info": "QjY70",
  "file_upload_type_icon": "Q-HfX",
  "file_upload_status_icon_container": "Y002w",
  "file_upload_status_icon": "vTp-T",
  "file_upload_description": "h-Tpx",
  "file_upload_name_container": "ajKKV",
  "file_upload_name": "ibxZI",
  "file_upload_extension": "gKhMK",
  "file_loader_icon": "J9-Kd",
  "file_upload_icon_frame": "daPsH",
  "file_upload_icon_background": "vRkpU"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
